// extracted by mini-css-extract-plugin
export default {"button":"Button_button__OOMYT","primary":"Button_primary__8Xpxy","secondary":"Button_secondary__GBY7J","nv":"Button_nv__GL3Ml","secondaryNv":"Button_secondaryNv__3cJvL"};